import sanitizeHTML from "@/lib/sanitizeHTML";
import { userSignatureToDomainMapper } from "@/mappers/user/userSignatureMapper";
import { useUserSignatureList } from "@cs_teamwaydev/mailvista-sdk_react";
import { useMemo } from "react";
import useLiveErrorNotifier from "../utils/useLiveErrorNotifier";
import getSignatureTemplate from "./getTemplate";

const useGetUserSignature = () => {
    const { data: signatures, isLoading, error } = useUserSignatureList();
    useLiveErrorNotifier(error, {
        titleTranslationKey: "errors.signature.get",
    });

    return useMemo(() => {
        // TODO: the SDK will use another method to get the signature once template is implemented
        const params =
            signatures &&
            (signatures[0] ? userSignatureToDomainMapper(signatures[0]) : null);

        return {
            userSignatureParams: { data: params, isPending: isLoading, error },
            userSanitizedSignature: {
                data: params && sanitizeHTML(getSignatureTemplate(params)),
            },
        };
    }, [signatures, isLoading, error]);
};

export default useGetUserSignature;
